import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { clearDrawingDraftOnLogout } from '../components/drawing/drawingDraftStorage'

const useAuthStore = create(
  persist(
    (set, get) => ({
      user: null,
      token: null,
      refreshToken: null,
      isAuthenticated: false,
      
      setAuth: (user, token, refreshToken) => set({
        user,
        token,
        refreshToken,
        isAuthenticated: true
      }),
      
      clearAuth: () => {
        const uid = get().user?.id
        clearDrawingDraftOnLogout(uid)
        set({
          user: null,
          token: null,
          refreshToken: null,
          isAuthenticated: false,
        })
      },

      /** Called after silent token refresh so Zustand + persist stay in sync with api interceptor. */
      updateTokens: (token, refreshToken) =>
        set({
          token,
          refreshToken,
          isAuthenticated: true,
        }),
      
      updateUser: (user) => set({ user })
    }),
    {
      name: 'auth-storage',
    }
  )
)

/**
 * Synchronous read of persisted auth (same shape as zustand persist `auth-storage`).
 * Use when the in-memory store is not yet rehydrated (e.g. first paint in a new tab).
 */
export function readPersistedAuthFromStorage() {
  if (typeof window === 'undefined') return { token: null, user: null }
  try {
    const raw = localStorage.getItem('auth-storage')
    if (!raw) return { token: null, user: null }
    const parsed = JSON.parse(raw)
    const s = parsed?.state
    if (!s || typeof s !== 'object') return { token: null, user: null }
    return {
      token: s.token ?? null,
      user: s.user ?? null,
    }
  } catch {
    return { token: null, user: null }
  }
}

export default useAuthStore
